const servers = [
  "https://connect.wehrle.de",
  "https://biesenthal.m-fair-connect.de",
  "https://demo01.m-fair-connect.de",
  "https://demo02.m-fair-connect.de",
  "https://develop.m-fair-connect.de",
  "https://ees-energy.m-fair-connect.de",
  "https://ls.m-fair-connect.de",
  "https://herz-hv.m-fair-connect.de",
  "https://mestate.m-fair-connect.de",
  "https://absys.m-fair-connect.de",
  "https://inosia.m-fair-connect.de",
  "https://asi-service.m-fair-connect.de",
  "https://wohlfahrt.m-fair-connect.de",
  "https://metromess.m-fair-connect.de",
  "https://sk-soft.m-fair-connect.de",
  "https://niersberger.m-fair-connect.de",
  "https://bernhardt.m-fair-connect.de",

  "https://staging.m-fair-connect.de",

  // Prod
  "https://key.wehrle.de",
]

export default servers;